import React, {Component} from 'react';
import { connect } from "react-redux";
import axios from "axios";
import FormTemplate from "../common/form/FormTemplate";
import { setSelectedControlPanelType, UserAccessControlPanelKey } from "../../redux/actions/controlPanelActions";
import configData from "../../config/config.json";
import { handleError } from '../../redux/actions/commonStuff';
import { LOADING_STATUES } from "../../components/constants/constants";

const componentName = UserAccessControlPanelKey;

const matchDispatchToProps = (dispatch) => {
  return { 
    setSelectedControlPanelType: () => dispatch(setSelectedControlPanelType(componentName)),
  }
}

class UserAccess extends Component {

  state = {
    guestUserName: "",
    limitLoginAttempts: false,
    maxloginAttempts: "0",
    inactivityTimeLimit: false,
    inactivityTimeLimitPeriod: 0,
    useRequestLimit: true,
    maxRequestsPerMin: 20,
    loadingStatus: ""
  }

  handleSubmit = (event) => {
    event.preventDefault();
  
    if (this.state.loadingStatus === "") {
      this.setState({
        loadingStatus: LOADING_STATUES.LOADING
      })
    } else {
      return;
    }

    axios.post(configData.LANDSHARK_SERVER_URL + "controlPanel/countyConfig/userAccess", this.state, { withCredentials: true })
    .then(
      (response) => {
        this.setState({ 
          loadingStatus: LOADING_STATUES.SUCCESS
        });
      },
      (error) => {
        handleError(error, this.props.history);
      }
    );
  }

  handleChange = (event) => {
    let value = event.target.value;
    value = value === "true" || value === "false" ? JSON.parse(event.target.value) : value;
    this.setState({
      loadingStatus: "",
      [event.target.id]: value ? value : (event.target.type === 'number' ? 0 : value)
    })
  }

	componentDidMount() {
    this.props.setSelectedControlPanelType();
   
    axios.get(configData.LANDSHARK_SERVER_URL + "controlPanel/countyConfig/userAccess", { withCredentials: true })
    .then(
      (response) => {
        const content = response.data.content;
        this.setState( {
          guestUserName: content.guestUserName,
          limitLoginAttempts: content.limitLoginAttempts,
          maxloginAttempts: content.maxloginAttempts,
          inactivityTimeLimit: content.inactivityTimeLimit,
          inactivityTimeLimitPeriod: content.inactivityTimeLimitPeriod,
          useRequestLimit: content.useRequestLimit,
          maxRequestsPerMin:  content.maxRequestsPerMin,
          loadingStatus : ""
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }
  
  render() {
    const formProps = {
      componentName: componentName,
      pageHeading: "User Admin - Access",
      onChange: this.handleChange,
      onSubmit: this.handleSubmit,
      successIndicator: this.state.loadingStatus === LOADING_STATUES.SUCCESS,
      loadingIndicator: this.state.loadingStatus === LOADING_STATUES.LOADING,
      formGroupRows: [
        {
          formGroups: [{ id: 'guestUserName', label: 'Guest Username', fieldType: 'text', value: this.state.guestUserName} ] 
        },
        {
          formGroups: [{ id: 'limitLoginAttempts', label: 'Limit User Login Attempts ', fieldType: 'select', value: this.state.limitLoginAttempts },
                       { id: 'maxloginAttempts', label: 'Max Login Attempts', fieldType: 'number', disableField: this.state.limitLoginAttempts === false, value: this.state.maxloginAttempts }]
        },       
        {
          formGroups: [{ id: 'inactivityTimeLimit', label: 'Inactivity Time Limit', fieldType: 'select', value: this.state.inactivityTimeLimit },
                       { id: 'inactivityTimeLimitPeriod', label: 'Minutes', fieldType: 'number', maxValue: 120, disableField: this.state.inactivityTimeLimit === false, value: this.state.inactivityTimeLimitPeriod }]
        },
        {
          formGroups: [{ id: 'useRequestLimit', label: 'Limit Requests Per Search Per Minute Per User', fieldType: 'select', value: this.state.useRequestLimit },
            { id: 'maxRequestsPerMin', label: 'Max Requests Per Min', fieldType: 'number', maxValue: 120, disableField: this.state.useRequestLimit === false, value: this.state.maxRequestsPerMin }]
        },
      ]
    }

    return <FormTemplate {...formProps} />
  }
}

export default connect(null, matchDispatchToProps)(UserAccess);